import { render } from "./ShaclComponents.vue?vue&type=template&id=799ff984&scoped=true"
import script from "./ShaclComponents.vue?vue&type=script&lang=js"
export * from "./ShaclComponents.vue?vue&type=script&lang=js"

import "./ShaclComponents.vue?vue&type=style&index=0&id=799ff984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799ff984"]])

export default __exports__